import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

const VARIANTS = {
  warning: '#FFB661',
  error: '#FC0167',
}

function Warning({ color = 'icon.white', variant = 'warning', ...props }) {
  const fill = VARIANTS[variant]
  return (
    <IconBase viewBox='0 0 26 26' {...props}>
      <Circle cx='13' cy='13' r='13' fill={fill} />
      <Path
        d='M13.0012 13.0291V10.9453'
        stroke={color}
        fill={fill}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.0007 14.7018C12.9238 14.7018 12.8614 14.7642 12.862
         14.8411C12.862 14.918 12.9244 14.9804 13.0012 14.9804C13.0781
          14.9804 13.1405 14.918 13.1405 14.8411C13.1405 14.7642 13.0781
           14.7018 13.0007 14.7018'
        stroke={color}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.1318 8.02367L18.3991 15.492C18.895 16.3601 18.2682 17.4404
         17.2686 17.4404H8.73389C7.73377 17.4404 7.10695 16.3601 7.60339
          15.492L11.8708 8.02367C12.3706 7.14836 13.632 7.14836 14.1318
           8.02367Z'
        stroke={color}
        fill='none'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Warning.propTypes = {
  color: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
}

export default Warning
